import CoachConfigurations from './CoachConfigurations';

export default CoachConfigurations;
